module.exports = __webpack_public_path__ + "img/152.5a42886c.jpg";